// extracted by mini-css-extract-plugin
export default {"info":"Painel_info__DN3NN"};